import { render, staticRenderFns } from "./manage-certificat-form.html?vue&type=template&id=8c06d944&scoped=true&external"
import script from "./manage-certificat-form.js?vue&type=script&lang=js&external"
export * from "./manage-certificat-form.js?vue&type=script&lang=js&external"
import style0 from "./manage-certificat-form.scss?vue&type=style&index=0&id=8c06d944&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c06d944",
  null
  
)

export default component.exports